import {Hour} from '../types/Hour';

/**
 * Checks if given hour is inside the disabled hours range.
 */
export const isHourDisabled = (hour: Hour, minHour: Hour, maxHour: Hour) =>
  hour < minHour || hour > maxHour;
